import { Badge, GoogleAdsIcon, LinkedinAdsIcon } from '@tinct/web-components';
import type { AdsProviderType } from '@tinct/core-api-models';

export const ADS_PROVIDER_LABELS: Record<AdsProviderType, string> = {
  google_ads: 'Google Ads',
  linkedin_ads: 'LinkedIn Ads',
};

export const isAdsProviderType = (value: unknown): value is AdsProviderType =>
  value === 'google_ads' || value === 'linkedin_ads';

type AdsProviderIconProps = { providerType: AdsProviderType; size?: number };

export function AdsProviderIcon({ providerType, size = 12 }: AdsProviderIconProps) {
  return providerType === 'linkedin_ads' ? (
    <LinkedinAdsIcon width={size} height={size} />
  ) : (
    <GoogleAdsIcon width={size} height={size} />
  );
}

type AdsProviderBadgeProps = {
  providerType: AdsProviderType | null | undefined;
  className?: string;
};

/**
 * Names the provider an ads campaign came from (Google Ads / LinkedIn Ads).
 * Renders nothing when the provider is unknown — e.g. a projection without
 * `integrationId`, or no ads integration to resolve it against.
 */
export function AdsProviderBadge({ providerType, className }: AdsProviderBadgeProps) {
  if (!providerType) return null;
  return (
    <Badge variant="secondary" className={`gap-1.5 ${className ?? ''}`.trim()}>
      <AdsProviderIcon providerType={providerType} />
      {ADS_PROVIDER_LABELS[providerType]}
    </Badge>
  );
}
